import React, {  useState, useEffect } from 'react'
import 'video-react/dist/video-react.css';
import { useLocation } from "react-router-dom";
import moment from 'moment'
import DayPicker from 'react-day-picker';
import LOCALE from '../datepicker/DatePickerLocale'
import { useHistory } from 'react-router-dom'
import Trailer from './components/Trailer'
import ShowtimeProgram from './components/ShowtimeProgram';
import _ from 'lodash'
import ShowtimeListItems from './components/ShowtimeListItems'
import ShowtimeList from './components/ShowtimeList'
export default function EbilletMovieContainer() {
    
    const [trailerPlaying,setTrailerPlaying] = useState(false)
    const [showCalendar, setShowCalendar] = useState(false)
  //  const [currentStartDate, setCurrentStartDate] = useState(moment())
    const history  = useHistory();
    const location = useLocation();
    const clickedMovie = location.state.clickedMovie
    const futureFilms = location.state.futureFilms ? location.state.futureFilms : ''
    const allEvents = location.state.eventsWithFilter /*? location.state.eventsWithFilter : location.state.allEvents*/
    const selectedMovieId = location.state.movie_id
    const movies = location.state.movieData
    const [movie, setMovie] = useState(movies?.length > 1 ? chosenMovie() : movies && movies[0])
    const already_selected_date = location.state.selectedDate
    const already_selectednr = location.state.selected
    const [selectedDate, setSelectedDate] = useState(already_selected_date ? already_selected_date : moment().format('DD-MM-YYYY'))
    const allEventsTypes = location.state.allEventsTypes
    const [calendarDate, setCalendarDate] = useState(  new Date());
    const [selected, setSelected] = useState(already_selectednr ? already_selectednr : 1);
    const selectedOrgs = location.state.organizers
  
    const orgsArr = location.state.allOrganizers

    function chosenMovie() {
        let movie 
        movies.map((mov) => {
            if (mov._no == selectedMovieId) {
                movie = mov              
            }
            return movie
        })
        return movie
   } 
   

    let eventsWithMovieArr = []
    allEvents && allEvents.sort((a, b) => a.dateTime > b.dateTime ? 1 : -1).map(ev => {
        
          
              if (ev._movieNo === movie._no &&  ev.webEnable._show === 1) {           
                eventsWithMovieArr.push(ev)
            }

        })

    function getUnique(arr, index) {
        
        const unique = arr
            .map(e => e[index])
        
            // store the keys of the unique objects
            .map((e, i, final) => final.indexOf(e) === i && i)
            // eliminate the dead keys & store unique objects
            .filter(e => arr[e]).map(e => arr[e]);

        return unique;
    }

   // console.log(eventsWithMovieArr)
    function makeShowtimeArr(org) {
        let showtimeNr = []
        eventsWithMovieArr.map(e => {
            if (org._organizerNo === e._organizerNo) {
                showtimeNr.push(e._no)
            }
        })
        return showtimeNr
    }

  
    function moviesShowtimes(org) {
        let showtimes = []
        eventsWithMovieArr.map(e => {
          // console.log(e, 'e')
            if (org._organizerNo === e._organizerNo) {
                let event = Object.assign( e )
               // console.log(event, 'event')
                if (event._eventTypeNo === 0) {
                    event.type = null
                }
                else event.type = allEventsTypes.filter(ev => { return ev._no === event._eventTypeNo })
                showtimes.push( e )          
            }

        })
        
        return showtimes
    }

   
    function findBioName(event) {
       // console.log(event, 'event')
        let bio     
        let dt = event.dateTime && moment(event.dateTime).format('DD-MM-YYYY')
       
        orgsArr.map(org => {
            if (org._no === event._organizerNo) {              
                bio = org.name
            }
        })
        return bio
    }

   

   

    let date_Arr = []
   
    let movieAtBios = []   // ebillet
    for (let i = 0; i < eventsWithMovieArr.length; i++) {
        movieAtBios.push({
            bio_name: findBioName(eventsWithMovieArr[i]),
            org: eventsWithMovieArr[i]._organizerNo,
            validShowtimes: moviesShowtimes (eventsWithMovieArr[i]), 
            movieNo: eventsWithMovieArr[i]._movieNo,
            showtimeArr: makeShowtimeArr(eventsWithMovieArr[i]),
         
        })
        date_Arr.push(moment(eventsWithMovieArr[i].dateTime).format('DD-MM-YYYY'))
    }

 
    const movieAtCinemas = getUnique(movieAtBios, 'bio_name')
   
    function isEmpty(obj) {
        for (const prop in obj) {
            if (Object.hasOwn(obj, prop)) {
                return false;
            }
        }

        return true; 
    }
   
    const premiere = movie.openingDate ? <p className="premiere film-info-text" style={{ marginTop: '15px', marginBottom: '10px' }}><span style={{color:'#949494'} }>Premiere: </span><label>{moment(movie.openingDate).locale('da').format('LL')}</label></p> : null;

    const scriptWriters = movie.scriptwriters && movie.scriptwriters.item.length > 0 ?
        <p className='film-info-text'> <span style={{ color: '#949494' }}>{movie.scriptwriters.item.length ? 'Manuskript' : ''}</span>
            <label style={{fontWeight:'normal'} }>{_.map(movie.scriptwriters, (scriptWriter) => scriptWriter).join(', ')}</label>
        </p> : null;

    const originalTitel = movie.length && <p className='film-info-text'>
        <span style={{ color: '#949494' }}>Orig. titel:</span>
        <label style={{ fontWeight: 'normal' }}> {movie.originalName}</label>
    </p>

    const actors = movie.actors && <p className='film-info-text'>
        <span style={{ color: '#949494' }}>Skuespillere:</span>
        <label style={{ fontWeight: 'normal' }}>{Array.isArray(movie.actors.item) === true ?  _.map(movie.actors.item, (actor) => actor).join(', ') : movie.actors.item}</label>
    </p>

    const description = movie.synopsis && isEmpty(movie.synopsis) === false ? <label key={movie.id} style={{ whiteSpace: 'pre-line', marginTop: '2px', fontFamily: 'Open sans', fontWeight: 400 }} className="description" dangerouslySetInnerHTML={{ __html: movie.synopsis.replace(/(?:\r\n|\r|\n)/g, '<br />') }} /> : null;

    const synopsis = movie.synopsis && isEmpty(movie.synopsis) === false && <p className='film-info-text' style={{ }}>
        <span style={{ color: '#949494' }}>Synopsis:</span>
        {description}    
         </p>
    
    const directors = movie.directors && <p className='film-info-text'>
        <span style={{ color: '#949494' }}>Instruktør:</span>
        <label style={{ fontWeight: 'normal' }}> {Array.isArray(movie.directors.item) === true ? _.map(movie.directors.item, (actor) => actor).join(', ') : movie.directors.item}</label>
    </p>
   
    const genre = movie.genre && <p className='film-info-text'>
        <span style={{ color: '#949494' }}>Genre:</span>
        <label style={{ fontWeight: 'normal' }}>{movie.genre} </label>
    </p>

    const length = movie.length && <p className='film-info-text'>
        <span style={{ color: '#949494' }}>Længde:</span>
        <label style={{ fontWeight: 'normal' }}> {movie.length}</label>
    </p>

    const censur = movie.censoring && <p className='film-info-text'>
        <span style={{ color: '#949494' }}>Aldersgrænse:</span>
        <label style={{ fontWeight: 'normal' }} > {movie.censoring}</label>
    </p>
  
    //---------choose version -----
   // const [selectedVers, setSelectedVers] = useState(0);
    function secondVersion() {
       
        let movie
        movies.map((mov) => {
            if (mov._no != selectedMovieId) {
                movie = mov
               
            }
        })
        return movie
    }

  //  console.log(secondVersion().name, 'second version')
    const lists = movies
      
    //    clickedMovie ? 
    //    [
    //            { id: 0, title: clickedMovie[0].name.split('-')[1] ? clickedMovie[0].name.split('-')[1] : 'Uden tekster' },
    //            movies.length > 1 ? { id: 1, title: secondVersion().name.split('-')[1] ? secondVersion().name.split('-')[1] : 'Uden tekster'} : ''       

    //        ]
    //: []
 

    const handleVersion = (list) => {
       
        setMovie(list)
       
    }

   
   

    
    const trailerUrl = `https://admin.ebillet.dk/trailers/${movie.vimeoId}.mp4`
    
    const trailerPoster = `https://ebillet.dk/poster/advertisement/${movie.sliderNoText}`

    function navBack() {
        history.goBack()
    }

    
    const lastShowtimeDay = date_Arr[date_Arr.length - 1];
 


    const nextShowtimeDate = moment(eventsWithMovieArr[0]?.dateTime).format('DD-MM-YYYY')  // the first showtime date for kommende films

   
    return (
        <div className='film-details'>
            <main className='Movie' >
                <p style={{ fontSize: '30px', fontWeight: 600, color: 'white', marginBottom: '50px' }}>{movie && movie.name}</p>

                { movie.vimeoId != null &&
                    <div className='' style={{}}>
                    {trailerUrl ? <Trailer trailerUrl={trailerUrl} trailerPoster={trailerPoster} setTrailerPlaying={setTrailerPlaying} />
                        : null}


                </div>
                }
               
                <div className='info-container' style={{ marginTop: trailerPlaying === true ? '0px' : '0px' }}>
              
                <div className='Poster'>
                        <img className='filmPoster' src={'https://poster.ebillet.dk/' + `${movie.largePath}`} />
                        <div className='age-banner poster-banner'>{isEmpty(movie.censoring) === false ? <img src={movie.censorImage} alt='age-banner' /> : null}</div>
                </div>
                    <div className='MovieInfo'>
                        <p className='film-title' style={{ fontSize: '30px', fontWeight: 500, letterSpacing:'0.3px' }}>{movie && movie.name}</p>
                        {premiere}
                        <hr style={{ borderBottom: 'none', opacity:'0.1',margin:'28px 0px' }} />
                        {synopsis}
                      
                        <hr style={{ borderBottom: 'none', opacity: '0.1', margin: '28px 0px' }} />
                        <br />
                        { isEmpty(movie.originalName) === false && originalTitel }
                        {scriptWriters }
                        {actors}
                        {directors}
                        {isEmpty(movie.genre) === false && genre}
                        {length}             
                        {isEmpty(movie.censoring) === false && censur}

                </div>
               
                </div>
              
            </main>
            <br />
            <section>
                {movie._movieBaseNo > 0 && movies.length > 1 ? 
              
                    <div  style={{ maxWidth: '1170px', margin: 'auto' }}>
                        <div className='versionContainer' >
                            <p style={{ color: 'white', margin: '16px', alignContent: 'center', fontSize: '19px', fontWeight: 500, letterSpacing: '0.44px' }}> Vælg version</p>
                            <div className='versioner' style={{marginLeft:movies.length === 2 ? '25%' : ''} } >

                                {lists.map((list, index) => (
                                   
                                  <div style={{
                                        height: '39px', borderRadius: '6px', backgroundColor:
                                            list._no === movie._no
                                                ? "#0E9D61"
                                                : "#404040", border: list._no !== movie._no ? '1px solid rgba(247, 247, 247, 0.50) ' : '',marginRight:'16px'
} }>
                            <button
                                
                                key={list.id}
                                onClick={() => handleVersion(list)}
                                style={{
                                    width: list._no === movie._no ? '184px' : '160px',
                                     letterSpacing:'0.36px',
                                    fontWeight: list._no === movie._no ? 500 : 400,
                                    color: 'white', fontSize: list._no === movie._no ? '19px' :'18px',marginTop:'2px'
                                }}
                                        >
                                           
                                            {list.name.split('-')[1] ? list.name.split('-')[1] : 'uden tekster' }
                            </button>
                            </div>
                        ))}

                    </div>
                    </div>
                </div>
                    : ''}
                <br />
              
               
               

            </section>
         
            <section className='orgs_container'>
              
                   
                    <ShowtimeList movieAtCinemas={movieAtCinemas} lastShowtimeDay={lastShowtimeDay}
                        already_selected_date={futureFilms === true ? nextShowtimeDate : already_selected_date} />

              
            </section>

            <br></br>
            <br></br>
            <div className='back_btn_cont'>
                <div className='back_btn'>
                  <span className=''>             
                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none">
                       <path d="M8 0.5H4.57143L0 6L4.57143 11.5H8L3.42857 6L8 0.5Z" fill="white" />
                   </svg>
                  </span>
                    <button onClick={navBack} style={{fontSize:'15px',fontWeight:700,color:'white'} } >
                        Tilbage til oversigt</button>
                </div>
                </div>
            <br></br> <br></br>
            </div>
    )
}